'use strict';

/**
 * @classname BtnInvoice
 * @classdesc 領収書発行ボタン
 */
export default class BtnInvoiceDownload {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--cancel
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnInvoice
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);

		var invoiceName = document.getElementById('invoice-name').value;
		var downloadUrl = this._$e.attr('data-download-url');
		var downloadFilename = this._$e.attr('data-download-filename');

        var a = document.createElement('a');
		a.href = downloadUrl + '?invoice_name=' + invoiceName;
        a.download = downloadFilename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

		setTimeout(function() {
			location.reload();
		}, 2000);
	};
};
